import React from 'react';
import SingleVoiceArtistComponent from '../components/SingleVoiceArtist';

import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function SingleVoiceArtist(props) {
  return (
    <AddonsContextConsumer>
      {
      ({
        constants: { VOICE_OVER_ARTIST },
        actions: { getBillingEntityCode }
      }) =>
      <SingleVoiceArtistComponent
        {...props}
        VOICE_OVER_ARTIST={VOICE_OVER_ARTIST}
        getBillingEntityCode={getBillingEntityCode} />}


    </AddonsContextConsumer>);

}

export default SingleVoiceArtist;